import { defineStore } from "pinia";

export const useLanguageStore = defineStore("languageStore", {
  state: () => ({
    isOpenSwitchLangModal: false,
  }),

  actions: {
    changeSwitchLangModalState(isOpen: boolean) {
      this.isOpenSwitchLangModal = isOpen;
    },
  },
});
